import { render, staticRenderFns } from "./OrderPrint.vue?vue&type=template&id=f83a7e70&scoped=true"
import script from "./OrderPrint.vue?vue&type=script&lang=js"
export * from "./OrderPrint.vue?vue&type=script&lang=js"
import style0 from "./OrderPrint.vue?vue&type=style&index=0&id=f83a7e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83a7e70",
  null
  
)

export default component.exports